import { useEffect, useState, useRef } from "react";
import { useSnackbar } from "notistack";
import axios from "axios";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import "./companiesItemsData.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as Action from "../../../../store/redux/client_reducer.js";
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

import IsLoading from "../../../../IsLoading.jsx";
import FilterProducts from "./filters/FilterProducts.jsx";
import ExportPDFButton from "./exports/ProductsPDFExport.jsx";
import ExportExcelJSButton from "./exports/ProductsExcelExport.jsx";
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

// import from MUI
              import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
 
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ArrowOutward from "@mui/icons-material/ArrowOutward"; 
import SkipNextIcon from "@mui/icons-material/SkipNext";
import PostAddIcon from "@mui/icons-material/PostAdd";

import SkipPreviousIcon from "@mui/icons-material/SkipPrevious"; 
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"; 
import Settings from "@mui/icons-material/Settings";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import AccessTime from "@mui/icons-material/AccessTime";
import ArrowForward from "@mui/icons-material/ArrowForward"; 
import Search from "@mui/icons-material/Search"; 
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined"; 
import ListAltIcon from "@mui/icons-material/ListAlt";
import PrintIcon from "@mui/icons-material/Print"; 
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined"; 
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart"; 
import ItemSortDropdown from "./companies-items-comps/ItemSortDropdown.jsx";
 
export default function CompaniesItemsData({
  handleSubNavigator,
  breadcrumbs,
  data,
  setIsMobileNavOpen,
}) {
  const [itemsData, setItemsData] = useState([])
  const [isViewDropdownOpen, setIsViewDropdownOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({
  key: "name",
  direction: "asc",
});
    const [searchParams, setSearchParams] = useSearchParams();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [changeview, setChangeView] = useState("gird");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState("");
  const [displayContent, setDisplayContent] = useState("main-display");
  const [search, setSearch] = useState("");
  // Paginations Functions
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openLimit, setOpenLimit] = useState(false);
  const totalPages = Math.ceil(itemsData?.length / rowsPerPage);
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentRows = itemsData?.slice(start, end);

  const productions = itemsData?.filter(
    (item) => item.itemType === "Production",
  );
  const services = itemsData?.filter((item) => item.itemType === "Service");
  const products = itemsData?.filter((item) => item.itemType === "Product");

  const currentTab = useSelector(
    (state) => state.clientFunction?.dashboard?.currentTab,
  );

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////

  async function apiGetAllItems() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/manage_products/client/${data?.clientId}/items-data/api-get-company-items`,
      );

      if (response?.data?.status === 201) { 
        setItemsData(response.data.productDB)
      } else {
        enqueueSnackbar(response?.data?.message || "Failed to fetch products", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error?.code || "REQUEST_FAILED");

      enqueueSnackbar("Server error while fetching products", {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  }

  // /////////////////////////////////////////////////////////
  // Redux functions for sub-navigation
  // /////////////////////////////////////////////////////////
  function handleCurrentTAB(item) {
    dispatch(DispatchCurrentTAB(item));
  }
  const DispatchCurrentTAB = (item) => async (dispatch) => {
    try {
      dispatch(Action.dispatchCurrentTAB({ item }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };
  function handlePrint(data) {
    dispatch(DispatchPrinting(data));
    // navigate(`/clients/${id}}/account/data_printing`);
    window.open(`/clients/${id}/account/data_printing`, "_blank");
  }
  const DispatchPrinting = (data) => async (dispatch) => {
    try {
      dispatch(Action.dispatchPrintData({ data }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };

  // ////////////////////////////////////////////////////////////
  function getPagination(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    if (current <= 4) {
      return [1, 2, 3, 4, 5, "...", total];
    }

    if (current >= total - 3) {
      return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    }

    return [1, "...", current - 1, current, current + 1, "...", total];
  }

  function switchActiveTab() {
    switch (currentTab) {
      case "items-data":
        return <ItemsLists setSearchParams={setSearchParams} search={search} setSearch={setSearch} />;
      case "products":
        return <Products setSearchParams={setSearchParams} search={search} setSearch={setSearch} />;
      case "productions":
        return <Production setSearchParams={setSearchParams} search={search} setSearch={setSearch} />;
      case "services":
        return <Services setSearchParams={setSearchParams} search={search} setSearch={setSearch} />;
      default:
        return <ItemsLists setSearchParams={setSearchParams} search={search} setSearch={setSearch} />;
    }
  }

  // //////////////////////////////////////////////////////////////////////////
  // COMPONENTS OF products PAGE
  // //////////////////////////////////////////////////////////////////////////

  function ItemsLists({ search, setSearch, setSearchParams }) {
    const filteredItems = itemsData?.filter((product) =>
      product.name.toLowerCase().includes(search.toLowerCase()),
    );
    function switchView() {
      switch (changeview) {
        case "grid":
          return <CardView currentRows={currentRows} />;
        case "table":
          return <TableView currentRows={currentRows} />;
        case "list":
          return <ItemListView currentRows={currentRows} />;
        default:
          return <TableView currentRows={currentRows} />;
      }
    }
    function ItemListView({ currentRows }) {
      const [openItemDrpdwn, setOpenItemDrpdwn] = useState(false);
      const [accordion, setAccordion] = useState(null);
      const [brands, setBrands] = useState("All brands");
      const [activeRow, setActiveRow] = useState(null);
      const dispatch = useDispatch();

      function handleItemDrpdwn(index) {
        setOpenItemDrpdwn(!openItemDrpdwn);
        if (activeRow === index) {
          setActiveRow(null);
        } else {
          setActiveRow(index);
        }
      }

     return (
    <div className="fx-cl space2">
      {currentRows?.map((filteredItems, index) => (
        <div
          className="relative companiesItemsLists"
          key={filteredItems?._id || filteredItems?.sku || index}
        >

          {/* =========================
              TOP PRODUCT INFORMATION
          ========================= */}
          <div className="fx-ac companiesItemsHeader">

            {/* Product Image */}
            <div className="companiesItemsProductImage">
              <img
                src={
                  filteredItems?.image ||
                  "/images/product-placeholder.png"
                }
                alt={filteredItems?.name || "Product"}
              />
            </div>

            {/* Product Name + Stock Status */}
            <div className="companiesItemsProductInfo fx fx-cl">

              <div className="companiesItemsProductName">
                {filteredItems?.name || "—"}
              </div>

              <div className="fx-ac companiesItemsStockStatus">

                <span className="companiesItemsStockIcon">
                  <span className="companiesItemsStockIconShape">
                    ▣
                  </span>
                </span>

                <span>
                  Stocked Product
                </span>

                <span className="companiesItemsStockCount">
                  {filteredItems?.quantity != null
                    ? `${filteredItems.quantity} in stock`
                    : "— in stock"}
                </span>

              </div>

            </div>

            {/* Divider */}
            <div className="companiesItemsVerticalDivider" />

            {/* Location */}
            <div className="companiesItemsInfoBlock">

              <div className="companiesItemsLabel">
                LOCATION
              </div>

              <div className="companiesItemsValue">
                {filteredItems?.location || "—"}
              </div>

            </div>

            {/* Reorder Point */}
            <div className="companiesItemsInfoBlock companiesItemsPointBlock">

              <div className="companiesItemsLabel">
                REORDER POINT
              </div>

              <div className="companiesItemsValue">
                {filteredItems?.reorderPoint ?? "—"}
              </div>

            </div>

            {/* Reorder Quantity */}
            <div className="companiesItemsInfoBlock companiesItemsQuantityBlock">

              <div className="companiesItemsLabel">
                REORDER QUANTITY
              </div>

              <div className="companiesItemsValue">
                {filteredItems?.reorderQuantity ?? "—"}
              </div>

            </div>

            {/* UOM */}
            <div className="companiesItemsInfoBlock companiesItemsUomBlock">

              <div className="companiesItemsLabel">
                UOM
              </div>

              <div className="companiesItemsValue">
                {filteredItems?.unit || "—"}
              </div>

            </div>

            {/* Three-dot menu */}
            <button
              type="button"
              className="companiesItemsMenuButton"
              aria-label="More options"
              onClick={() => handleItemDrpdwn(index)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

          </div>


          {/* =========================
              REORDER TIMELINE
          ========================= */}
          <div className="companiesItemsTimeline fx-ac">

            {/* Reorder Type */}
            <div className="companiesItemsType">

              <div className="companiesItemsLabel">
                REORDER TYPE
              </div>

              <div className="companiesItemsTypeValue">
                {filteredItems?.reorderType || "—"}
              </div>

            </div>

            {/* Timeline Divider */}
            <div className="companiesItemsTimelineDivider" />


            {/* Step 1 */}
            <div className="companiesItemsStep">

              <div className="companiesItemsStepIcon">

                <span className="companiesItemsStepIconInner">
                  ↧
                </span>

              </div>

              <div className="companiesItemsStepDate">
                {filteredItems?.reorderDate || "—"}
              </div>

            </div>


            {/* Progress Line */}
            <div className="companiesItemsProgressLine">
              <span></span>
            </div>


            {/* Step 2 */}
            <div className="companiesItemsStep">

              <div className="companiesItemsStepIcon">

                <span className="companiesItemsStepIconInner">
                  🚚
                </span>

              </div>

              <div className="companiesItemsStepDate">
                {filteredItems?.transferDate || "—"}
              </div>

            </div>


            {/* Progress Line */}
            <div className="companiesItemsProgressLine">
              <span></span>
            </div>


            {/* Step 3 */}
            <div className="companiesItemsStep">

              <div className="companiesItemsStepIcon">

                <span className="companiesItemsStepIconInner">
                  ✓
                </span>

              </div>

              <div className="companiesItemsStepDate">
                {filteredItems?.arrivalDate ||
                  filteredItems?.createdAt ||
                  "—"}
              </div>

            </div>


            {/* Final Status */}
            <div className="companiesItemsFinalStatus">
              {filteredItems?.status || "—"}
            </div>

          </div>

        </div>
      ))}
    </div>
  );
    }
    function TableView({ currentRows }) {
      const [openItemDrpdwn, setOpenItemDrpdwn] = useState(false);
      const [accordion, setAccordion] = useState(null);
      const [brands, setBrands] = useState("All brands");
      const [activeRow, setActiveRow] = useState(null);
      const dispatch = useDispatch();

      function handleItemDrpdwn(index) {
        setOpenItemDrpdwn(!openItemDrpdwn);
        if (activeRow === index) {
          setActiveRow(null);
        } else {
          setActiveRow(index);
        }
      }

      return (
        <div className="products ">
          <table className="fx-cl spacem">
            <thead className="fx-cl spacem">
              <tr>
                <th>Product</th>
                <th>Category</th>
                <th>Brand</th>
                <th>Purchase Price</th>
                <th>Selling Price</th>
                <th>Stock</th>
                <th>Unit</th>
                <th>Location</th>
                <th>Status</th>
              </tr>
            </thead>

            {search.length > 0 ? (
              <tbody className="fx-cl spacem">
                {" "}
                {filteredItems?.map((item, index) => (
                  <tr
                    key={index}
                    id={`${accordion === index && "productsAccordionOpen"}`}
                    className="productsRowTdCont fx-cl space1 relative"
                  >
                    <td
                      id={item?.sku}
                      className={`productsRowTd ${activeRow === index && "active_warehauseRow"}`}
                      onClick={() =>
                        accordion === index
                          ? setAccordion(null)
                          : setAccordion(index)
                      }
                    >
                      <span>
                        <strong>{item?.name}</strong>
                      </span>
                      <span>{item?.categoryId}</span>
                      <span>{item?.brand}</span>
                      <span>₦{item?.pricing?.costPrice?.toLocaleString()}</span>
                      <span>
                        ₦{item?.pricing?.sellingPrice?.toLocaleString()}
                      </span>
                      <span>{item?.inventories[0]?.quantity}</span>
                      <span>{item?.units?.baseUnit}</span>
                      <span>{item?.inventories?.[0]?.location}</span>
                      <span>{item?.status}</span>
                    </td>

                    <span className="productsAccordionCont">
                      <div className="productsAccordionDisc fx-ac space1">
                        <figure className="fx-ac fx-jc">
                          <span className="detialOpnPrcdt ">
                            <div className="fx-cl fx-ac fx-jc spacem">
                              <PrivacyTipOutlinedIcon
                                style={{
                                  fontSize: "9.5rem",
                                }}
                              />
                              <span className="fs1">More detials!</span>
                            </div>
                          </span>

                          <span className="defaultPrdtIct">
                            <ShoppingCartIcon
                              style={{
                                fontSize: "9.5rem",
                              }}
                            />
                          </span>
                        </figure>
                        <div className="productsAccordionDetails g g4 space1">
                          <div className="fx-cl spacem">
                            <span>Batch</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.batchNo}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Item SKU</span>
                            <p>
                              <strong>{item?.sku}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Base Unit</span>
                            <p>
                              <strong>{item?.units?.baseUnit}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Expiry Date</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.expiryDate}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Warehouse</span>
                            <p>
                              <strong>{item?.warehouses?.[0]?.location}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Barcode</span>
                            <p>
                              <strong>{item?.barcode}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Stock Available</span>
                            <p>
                              <strong>{item?.stock?.quantityAvailable}</strong>
                            </p>
                          </div>
                          <div className="fx-cl spacem">
                            <span>Date Created</span>
                            <p>
                              <strong>
                                {" "}
                                {new Date(item?.createdAt).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  },
                                )}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-ac space1">
                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <span>Return item</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                              <span>Edit</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <LocalPrintshopIcon />
                              <span>Discount</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </span>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody className="fx-cl spacem">
                {" "}
                {currentRows?.map((item, index) => (
                  <tr
                    key={index}
                    id={`${accordion === index && "productsAccordionOpen"}`}
                    className="productsRowTdCont fx-cl space1 relative"
                  >
                    <td
                      id={item?.sku}
                      className={`productsRowTd ${
                        activeRow === index && "active_warehauseRow"
                      }`}
                      onClick={() =>
                        accordion === index
                          ? setAccordion(null)
                          : setAccordion(index)
                      }
                    >
                      <span>
                        <strong>{item?.name}</strong>
                      </span>

                      <span>{item?.categoryId}</span>

                      <span>{item?.brand}</span>

                      <span>₦{item?.pricing?.costPrice?.toLocaleString()}</span>

                      <span>
                        ₦{item?.pricing?.sellingPrice?.toLocaleString()}
                      </span>

                      <span>{item?.inventories?.[0]?.stock?.quantity}</span>

                      <span>{item?.units?.baseUnit}</span>

                      <span>{item?.inventories?.[0]?.inventoryId}</span>

                      <span>{item?.status}</span>
                    </td>

                    <span className="productsAccordionCont">
                      <div className="productsAccordionDisc fx-ac space1">
                        <figure
                          className="fx-ac fx-jc"
                          onClick={(e) => {
                            setDisplayContent("previewAlpha");
                          }}
                        >
                          <span className="detialOpnPrcdt ">
                            <div className="fx-cl fx-ac fx-jc spacem">
                              <PrivacyTipOutlinedIcon
                                style={{
                                  fontSize: "9.5rem",
                                }}
                              />
                              <span className="fs1">More detials!</span>
                            </div>
                          </span>

                          <span className="defaultPrdtIct">
                            <ShoppingCartIcon
                              style={{
                                fontSize: "9.5rem",
                              }}
                            />
                          </span>
                        </figure>

                        <div className="productsAccordionDetails g g4 space1">
                          <div className="fx-cl spacem">
                            <span>Batch</span>
                            <p>
                              <strong>
                                {
                                  item?.inventories?.[0]?.batchTracking
                                    ?.batches?.[0]?.batchNo
                                }
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Item SKU</span>
                            <p>
                              <strong>{item?.sku}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Base Unit</span>
                            <p>
                              <strong>{item?.units?.baseUnit}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Expiry Date</span>
                            <p>
                              <strong>
                                {
                                  item?.inventories?.[0]?.batchTracking
                                    ?.batches?.[0]?.expiryDate
                                }
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Warehouse</span>
                            <p>
                              <strong>
                                {item?.inventories?.[0]?.inventoryId}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Barcode</span>
                            <p>
                              <strong>{item?.barcode}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Stock Available</span>
                            <p>
                              <strong>
                                {item?.inventories?.[0]?.stock?.quantity}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Date Created</span>
                            <p>
                              <strong>
                                {" "}
                                {new Date(item?.createdAt).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  },
                                )}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-ac space1">
                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <span>Return item</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                              <span>Edit</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <LocalPrintshopIcon />
                              <span>Discount</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </span>
                  </tr>
                ))}
              </tbody>
            )}

            {/* <tbody className="fx-cl spacem">
              {currentRows?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <strong>{item?.name}</strong>
                  </td>
                  <td>{item?.sku}</td>
                  <td>{item?.categoryId}</td>
                  <td>{item?.brand}</td>
                  <td>₦{item?.pricing?.costPrice?.toLocaleString()}</td>
                  <td>₦{item?.pricing?.sellingPrice?.toLocaleString()}</td>
                  <td>{item?.stock?.quantityAvailable}</td>
                  <td>{item?.units?.baseUnit}</td>
                  <td>{item?.warehouses?.[0]?.location}</td>
                  <td>{item?.status}</td>
                  <td>{new Date(item?.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody> */}
          </table>
        </div>
      );
    }

    function CardView({ currentRows }) {
      return (
        <div className="item-products-grid">
          {filteredItems?.map((product, index) => {
            const stock = product?.inventories?.[0]?.stock?.quantity ?? 0;

            const sellingPrice = product?.pricing?.sellingPrice ?? 0;

            const currency = product?.pricing?.currency || "NGN";

            const salesUnit = product?.units?.salesUnit || "Unit";

            const image = product?.images?.[0] || null;

            const brand = product?.brand || "";

            const sku = product?.sku || "";

            const status = product?.status || "";

            return (
              <article
                key={product?._id}
                className={`item-product-card ${
                  [
                    "item-card-themeOne",
                    "item-card-themeTwo",
                    "item-card-themeThree",
                    "item-card-themeFour",
                    "item-card-themeFive",
                  ][Math.floor(index / 4) % 5]
                }`}
                data-stock={stock}
                data-status={status}
                onClick={() => {
                  setSearchParams({ sku: product?.sku, index: index });
                  handleSubNavigator(
                    "item-explore-display",
                    "Item Preview",
                    "Item Preview",
                  );
                }}
              >
                {/* ============================================
                PRICE
            ============================================= */}

                <div className="item-product-card-price">
                  <span className="priceItemCont fx-ac spacem">
                    <span>{sellingPrice.toLocaleString()}</span>

                    <span>{currency}</span>
                  </span>
                </div>

                {/* ============================================
                PRODUCT IMAGE / ICON
            ============================================= */}
                <div className="itemCardTop fx-cl">
                  <div className="item-product-card-image-wrapper">
                    <div className="item-product-card-icon">
                      {image ? (
                        <img
                          src={image}
                          alt={product?.name || "Product"}
                          className="item-product-card-image"
                        />
                      ) : (
                        <InsertDriveFileIcon />
                      )}
                    </div>
                  </div>
                  {/* ==========================================
                  STOCK / DELIVERY BAR
              =========================================== */}

                  <div className="item-product-card-delivery">
                    {stock > 0
                      ? `Stock · ${stock} ${salesUnit}`
                      : "Out of stock"}
                  </div>
                </div>

                {/* ============================================
                PRODUCT CONTENT
            ============================================= */}

                <div className="item-product-card-content">
                  <div className="item-product-card-heading fx fx-ac fx-jb">
                    {/* PRODUCT NAME */}

                    <h3 className="item-product-card-name">{product?.name}</h3>

                    {/* ORDER / VIEW */}

                    <button type="button" className="item-product-card-order">
                      View
                      <ArrowOutward />
                    </button>
                  </div>

                  {/* ==========================================
                  PRODUCT TAGS
              =========================================== */}

                  <div className="item-product-card-tags">
                    {brand && (
                      <span className="item-product-card-tag">{brand}</span>
                    )}

                    {salesUnit && (
                      <span className="item-product-card-tag">{salesUnit}</span>
                    )}

                    {status && (
                      <span className="item-product-card-tag">{status}</span>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      );
    }
    return (
      <div className="fx-cl space2">
        <div className="fx-cl space2">
          <div className="fx-cl spacem">
            <div className="fx-ac fx-jb space2" style={{ fontSize: "1.2rem" }}>
              <span className="fx-ac spacem">
                <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                  Display:
                </strong>
                <span>
                  {itemsData?.length === 0
                    ? "0 to 0 of 0 entries"
                    : `${start + 1} to ${Math.min(
                        end,
                        itemsData?.length,
                      )} of ${itemsData?.length} entries`}
                </span>
              </span>
              <div className="products_entries-info fx-ac spacem">
                <h4>Rows</h4>
                <div className="products-page-limit">
                  <button
                    className="products-page-limit-btn"
                    onClick={() => setOpenLimit(!openLimit)}
                  >
                    {rowsPerPage} / page
                    <span className="products-page-limit-arrow">▾</span>
                  </button>

                  {openLimit && (
                    <ul className="products-limit-dropdown">
                      {[10, 20, 50, 100, 200, 500, 1000].map((n) => (
                        <li
                          key={n}
                          className="products-limit-item"
                          onClick={() => {
                            setRowsPerPage(n);
                            setCurrentPage(1);
                            setOpenLimit(false);
                          }}
                        >
                          {n} / page
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="products_row" id="printable">
              {switchView()}
            </div>
            <div className="fx-jc">
              <div className="products_pagination fx-ac space2">
                <button
                  className="fx-ac spacem"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  <SkipPreviousIcon />
                  Prev
                </button>
                <div className="fx-ac">
                  {getPagination(currentPage, totalPages)?.map((page, i) =>
                    page === "..." ? (
                      <span key={i} className="dots">
                        …
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`products_jumpto ${
                          currentPage === page ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ),
                  )}
                </div>

                <button
                  className="fx-ac spacem"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                  <SkipNextIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function Products({ search, setSearch, setSearchParams }) {
    const filteredProducts = products?.filter((product) =>
      product.name.toLowerCase().includes(search.toLowerCase()),
    );
    function switchView() {
      switch (changeview) {
        case "grid":
          return <CardView currentRows={currentRows} />;
        case "table":
          return <TableView currentRows={currentRows} />;
        default:
          return <TableView currentRows={currentRows} />;
      }
    }
    function TableView() {
      const [openItemDrpdwn, setOpenItemDrpdwn] = useState(false);
      const [accordion, setAccordion] = useState(null);
      const [brands, setBrands] = useState("All brands");
      const [activeRow, setActiveRow] = useState(null);
      const dispatch = useDispatch();

      function handleItemDrpdwn(index) {
        setOpenItemDrpdwn(!openItemDrpdwn);
        if (activeRow === index) {
          setActiveRow(null);
        } else {
          setActiveRow(index);
        }
      }

      return (
        <div className="products ">
          <table className="fx-cl spacem">
            <thead className="fx-cl spacem">
              <tr>
                <th>Product</th>
                <th>Category</th>
                <th>Brand</th>
                <th>Purchase Price</th>
                <th>Selling Price</th>
                <th>Stock</th>
                <th>Unit</th>
                <th>Location</th>
                <th>Status</th>
              </tr>
            </thead>
            {search.length > 0 ? (
              <tbody className="fx-cl spacem">
                {filteredProducts?.map((item, index) => (
                  <tr
                    key={index}
                    id={`${accordion === index && "productsAccordionOpen"}`}
                    className="productsRowTdCont fx-cl space1 relative"
                  >
                    <td
                      id={item?.sku}
                      className={`productsRowTd ${activeRow === index && "active_warehauseRow"}`}
                      onClick={() =>
                        accordion === index
                          ? setAccordion(null)
                          : setAccordion(index)
                      }
                    >
                      <span>
                        <strong>{item?.name}</strong>
                      </span>
                      <span>{item?.categoryId}</span>
                      <span>{item?.brand}</span>
                      <span>₦{item?.pricing?.costPrice?.toLocaleString()}</span>
                      <span>
                        ₦{item?.pricing?.sellingPrice?.toLocaleString()}
                      </span>
                      <span>{item?.inventories[0]?.quantity}</span>
                      <span>{item?.units?.baseUnit}</span>
                      <span>{item?.inventories?.[0]?.location}</span>
                      <span>{item?.status}</span>
                    </td>

                    <span className="productsAccordionCont">
                      <div className="productsAccordionDisc fx-ac space1">
                        <figure
                          className="fx-ac fx-jc"
                          onClick={(e) => {
                            setDisplayContent("previewAlpha");
                          }}
                        >
                          <span className="detialOpnPrcdt ">
                            <div className="fx-cl fx-ac fx-jc spacem">
                              <PrivacyTipOutlinedIcon
                                style={{
                                  fontSize: "9.5rem",
                                }}
                              />
                              <span className="fs1">More detials!</span>
                            </div>
                          </span>

                          <span className="defaultPrdtIct">
                            <ShoppingCartIcon
                              style={{
                                fontSize: "9.5rem",
                              }}
                            />
                          </span>
                        </figure>
                        <div className="productsAccordionDetails g g4 space1">
                          <div className="fx-cl spacem">
                            <span>Batch</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.batchNo}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Item SKU</span>
                            <p>
                              <strong>{item?.sku}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Base Unit</span>
                            <p>
                              <strong>{item?.units?.baseUnit}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Expiry Date</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.expiryDate}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Warehouse</span>
                            <p>
                              <strong>{item?.warehouses?.[0]?.location}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Barcode</span>
                            <p>
                              <strong>{item?.barcode}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Stock Available</span>
                            <p>
                              <strong>{item?.stock?.quantityAvailable}</strong>
                            </p>
                          </div>
                          <div className="fx-cl spacem">
                            <span>Date Created</span>
                            <p>
                              <strong>
                                {" "}
                                {new Date(item?.createdAt).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  },
                                )}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-ac space1">
                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <span>Return item</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                              <span>Edit</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <LocalPrintshopIcon />
                              <span>Discount</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <button
                        className="previewProductBtn fx-ac spacem"
                        onClick={(e) => {
                          setDisplayContent("add-new-item");
                        }}
                      >
                        <CandlestickChartIcon fontSize="large" />
                        <span>Preview Product</span>
                      </button>
                    </span>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody className="fx-cl spacem">
                {products?.map((item, index) => (
                  <tr
                    key={index}
                    id={`${accordion === index && "productsAccordionOpen"}`}
                    className="productsRowTdCont fx-cl space1 relative"
                  >
                    <td
                      id={item?.sku}
                      className={`productsRowTd ${activeRow === index && "active_warehauseRow"}`}
                      onClick={() =>
                        accordion === index
                          ? setAccordion(null)
                          : setAccordion(index)
                      }
                    >
                      <span>
                        <strong>{item?.name}</strong>
                      </span>
                      <span>{item?.categoryId}</span>
                      <span>{item?.brand}</span>
                      <span>₦{item?.pricing?.costPrice?.toLocaleString()}</span>
                      <span>
                        ₦{item?.pricing?.sellingPrice?.toLocaleString()}
                      </span>
                      <span>{item?.inventories[0]?.quantity}</span>
                      <span>{item?.units?.baseUnit}</span>
                      <span>{item?.inventories?.[0]?.location}</span>
                      <span>{item?.status}</span>
                    </td>

                    <span className="productsAccordionCont">
                      <div className="productsAccordionDisc fx-ac space1">
                        <figure
                          className="fx-ac fx-jc"
                          onClick={(e) => {
                            setDisplayContent("previewAlpha");
                          }}
                        >
                          <span className="detialOpnPrcdt ">
                            <div className="fx-cl fx-ac fx-jc spacem">
                              <PrivacyTipOutlinedIcon
                                style={{
                                  fontSize: "9.5rem",
                                }}
                              />
                              <span className="fs1">More detials!</span>
                            </div>
                          </span>

                          <span className="defaultPrdtIct">
                            <ShoppingCartIcon
                              style={{
                                fontSize: "9.5rem",
                              }}
                            />
                          </span>
                        </figure>
                        <div className="productsAccordionDetails g g4 space1">
                          <div className="fx-cl spacem">
                            <span>Batch</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.batchNo}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Item SKU</span>
                            <p>
                              <strong>{item?.sku}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Base Unit</span>
                            <p>
                              <strong>{item?.units?.baseUnit}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Expiry Date</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.expiryDate}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Warehouse</span>
                            <p>
                              <strong>{item?.warehouses?.[0]?.location}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Barcode</span>
                            <p>
                              <strong>{item?.barcode}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Stock Available</span>
                            <p>
                              <strong>{item?.stock?.quantityAvailable}</strong>
                            </p>
                          </div>
                          <div className="fx-cl spacem">
                            <span>Date Created</span>
                            <p>
                              <strong>
                                {" "}
                                {new Date(item?.createdAt).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  },
                                )}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-ac space1">
                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <span>Return item</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                              <span>Edit</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <LocalPrintshopIcon />
                              <span>Discount</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <button
                        className="previewProductBtn fx-ac spacem"
                        onClick={(e) => {
                          setDisplayContent("add-new-item");
                        }}
                      >
                        <CandlestickChartIcon fontSize="large" />
                        <span>Preview Product</span>
                      </button>
                    </span>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      );
    }

     function CardView({ currentRows }) {
      return (
        <>
      {
           search.length > 0 ?
          
        <div className="item-products-grid">
          {filteredProducts?.map((product, index) => {
            const stock = product?.inventories?.[0]?.stock?.quantity ?? 0;

            const sellingPrice = product?.pricing?.sellingPrice ?? 0;

            const currency = product?.pricing?.currency || "NGN";

            const salesUnit = product?.units?.salesUnit || "Unit";

            const image = product?.images?.[0] || null;

            const brand = product?.brand || "";

            const sku = product?.sku || "";

            const status = product?.status || "";

            return (
              <article
                key={product?._id}
                className={`item-product-card ${
                  [
                    "item-card-themeOne",
                    "item-card-themeTwo",
                    "item-card-themeThree",
                    "item-card-themeFour",
                    "item-card-themeFive",
                  ][Math.floor(index / 4) % 5]
                }`}
                data-stock={stock}
                data-status={status}
                onClick={() => {
                  setSearchParams({ sku: product?.sku, index: index });
                  handleSubNavigator(
                    "item-explore-display",
                    "Item Preview",
                    "Item Preview",
                  );
                }}
              >
                {/* ============================================
                PRICE
            ============================================= */}

                <div className="item-product-card-price">
                  <span className="priceItemCont fx-ac spacem">
                    <span>{sellingPrice.toLocaleString()}</span>

                    <span>{currency}</span>
                  </span>
                </div>

                {/* ============================================
                PRODUCT IMAGE / ICON
            ============================================= */}
                <div className="itemCardTop fx-cl">
                  <div className="item-product-card-image-wrapper">
                    <div className="item-product-card-icon">
                      {image ? (
                        <img
                          src={image}
                          alt={product?.name || "Product"}
                          className="item-product-card-image"
                        />
                      ) : (
                         <InsertDriveFileIcon />
                      )}
                    </div>
                  </div>
                  {/* ==========================================
                  STOCK / DELIVERY BAR
              =========================================== */}

                  <div className="item-product-card-delivery">
                    {stock > 0
                      ? `Stock · ${stock} ${salesUnit}`
                      : "Out of stock"}
                  </div>
                </div>

                {/* ============================================
                PRODUCT CONTENT
            ============================================= */}

                <div className="item-product-card-content">
                  <div className="item-product-card-heading fx fx-ac fx-jb">
                    {/* PRODUCT NAME */}

                    <h3 className="item-product-card-name">{product?.name}</h3>

                    {/* ORDER / VIEW */}

                    <button type="button" className="item-product-card-order">
                      View
                      <ArrowOutward />
                    </button>
                  </div>

                  {/* ==========================================
                  PRODUCT TAGS
              =========================================== */}

                  <div className="item-product-card-tags">
                    {brand && (
                      <span className="item-product-card-tag">{brand}</span>
                    )}

                    {salesUnit && (
                      <span className="item-product-card-tag">{salesUnit}</span>
                    )}

                    {status && (
                      <span className="item-product-card-tag">{status}</span>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
          :
        <div className="item-products-grid">
          {products?.map((product, index) => {
            const stock = product?.inventories?.[0]?.stock?.quantity ?? 0;

            const sellingPrice = product?.pricing?.sellingPrice ?? 0;

            const currency = product?.pricing?.currency || "NGN";

            const salesUnit = product?.units?.salesUnit || "Unit";

            const image = product?.images?.[0] || null;

            const brand = product?.brand || "";

            const sku = product?.sku || "";

            const status = product?.status || "";

            return (
              <article
                key={product?._id}
                className={`item-product-card ${
                  [
                    "item-card-themeOne",
                    "item-card-themeTwo",
                    "item-card-themeThree",
                    "item-card-themeFour",
                    "item-card-themeFive",
                  ][Math.floor(index / 4) % 5]
                }`}
                data-stock={stock}
                data-status={status}
                onClick={() => {
                  setSearchParams({ sku: product?.sku, index: index });
                  handleSubNavigator(
                    "item-explore-display",
                    "Item Preview",
                    "Item Preview",
                  );
                }}
              >
                {/* ============================================
                PRICE
            ============================================= */}

                <div className="item-product-card-price">
                  <span className="priceItemCont fx-ac spacem">
                    <span>{sellingPrice.toLocaleString()}</span>

                    <span>{currency}</span>
                  </span>
                </div>

                {/* ============================================
                PRODUCT IMAGE / ICON
            ============================================= */}
                <div className="itemCardTop fx-cl">
                  <div className="item-product-card-image-wrapper">
                    <div className="item-product-card-icon">
                      {image ? (
                        <img
                          src={image}
                          alt={product?.name || "Product"}
                          className="item-product-card-image"
                        />
                      ) : (
                        <InsertDriveFileIcon />
                      )}
                    </div>
                  </div>
                  {/* ==========================================
                  STOCK / DELIVERY BAR
              =========================================== */}

                  <div className="item-product-card-delivery">
                    {stock > 0
                      ? `Stock · ${stock} ${salesUnit}`
                      : "Out of stock"}
                  </div>
                </div>

                {/* ============================================
                PRODUCT CONTENT
            ============================================= */}

                <div className="item-product-card-content">
                  <div className="item-product-card-heading fx fx-ac fx-jb">
                    {/* PRODUCT NAME */}

                    <h3 className="item-product-card-name">{product?.name}</h3>

                    {/* ORDER / VIEW */}

                    <button type="button" className="item-product-card-order">
                      View
                      <ArrowOutward />
                    </button>
                  </div>

                  {/* ==========================================
                  PRODUCT TAGS
              =========================================== */}

                  <div className="item-product-card-tags">
                    {brand && (
                      <span className="item-product-card-tag">{brand}</span>
                    )}

                    {salesUnit && (
                      <span className="item-product-card-tag">{salesUnit}</span>
                    )}

                    {status && (
                      <span className="item-product-card-tag">{status}</span>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
          }
          </>
      );
    }
    return (
      <div className="fx-cl space2">
        <div className="fx-cl space2">
          <div className="fx-cl spacem">
            <div className="fx-ac fx-jb space2" style={{ fontSize: "1.2rem" }}>
              <span className="fx-ac spacem">
                <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                  Display:
                </strong>
                <span>
                  {itemsData?.length === 0
                    ? "0 to 0 of 0 entries"
                    : `${start + 1} to ${Math.min(
                        end,
                        itemsData?.length,
                      )} of ${itemsData?.length} entries`}
                </span>
              </span>
              <div className="products_entries-info fx-ac spacem">
                <h4>Rows</h4>
                <div className="products-page-limit">
                  <button
                    className="products-page-limit-btn"
                    onClick={() => setOpenLimit(!openLimit)}
                  >
                    {rowsPerPage} / page
                    <span className="products-page-limit-arrow">▾</span>
                  </button>

                  {openLimit && (
                    <ul className="products-limit-dropdown">
                      {[10, 20, 50, 100, 200, 500, 1000].map((n) => (
                        <li
                          key={n}
                          className="products-limit-item"
                          onClick={() => {
                            setRowsPerPage(n);
                            setCurrentPage(1);
                            setOpenLimit(false);
                          }}
                        >
                          {n} / page
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="products_row" id="printable">
              {switchView()}
            </div>
            <div className="fx-jc">
              <div className="products_pagination fx-ac space2">
                <button
                  className="fx-ac spacem"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  <SkipPreviousIcon />
                  Prev
                </button>
                <div className="fx-ac">
                  {getPagination(currentPage, totalPages)?.map((page, i) =>
                    page === "..." ? (
                      <span key={i} className="dots">
                        …
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`products_jumpto ${
                          currentPage === page ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ),
                  )}
                </div>

                <button
                  className="fx-ac spacem"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                  <SkipNextIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function Production({ search, setSearch, setSearchParams }) {
    const filteredProductions = productions?.filter((product) =>
      product.name.toLowerCase().includes(search.toLowerCase()),
    );
    function switchView() {
      switch (changeview) {
        case "grid":
          return <CardView currentRows={currentRows} />;
        case "table":
          return <TableView currentRows={currentRows} />;
        default:
          return <TableView currentRows={currentRows} />;
      }
    }

    function TableView() {
      const [openItemDrpdwn, setOpenItemDrpdwn] = useState(false);
      const [accordion, setAccordion] = useState(null);
      const [brands, setBrands] = useState("All brands");
      const [activeRow, setActiveRow] = useState(null);
      const dispatch = useDispatch();

      function handleItemDrpdwn(index) {
        setOpenItemDrpdwn(!openItemDrpdwn);
        if (activeRow === index) {
          setActiveRow(null);
        } else {
          setActiveRow(index);
        }
      }

      return (
        <div className="products ">
          <table className="fx-cl spacem">
            <thead className="fx-cl spacem">
              <tr>
                <th>Product</th>
                <th>Category</th>
                <th>Brand</th>
                <th>Purchase Price</th>
                <th>Selling Price</th>
                <th>Stock</th>
                <th>Unit</th>
                <th>Location</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody className="fx-cl spacem">
              {productions?.map((item, index) => (
                <tr
                  key={index}
                  id={`${accordion === index && "productsAccordionOpen"}`}
                  className="productsRowTdCont fx-cl space1 relative"
                >
                  <td
                    id={item?.sku}
                    className={`productsRowTd ${activeRow === index && "active_warehauseRow"}`}
                    onClick={() =>
                      accordion === index
                        ? setAccordion(null)
                        : setAccordion(index)
                    }
                  >
                    <span>
                      <strong>{item?.name}</strong>
                    </span>
                    <span>{item?.categoryId}</span>
                    <span>{item?.brand}</span>
                    <span>₦{item?.pricing?.costPrice?.toLocaleString()}</span>
                    <span>
                      ₦{item?.pricing?.sellingPrice?.toLocaleString()}
                    </span>
                    <span>{item?.inventories[0]?.quantity}</span>
                    <span>{item?.units?.baseUnit}</span>
                    <span>{item?.inventories?.[0]?.location}</span>
                    <span>{item?.status}</span>
                  </td>

                  <span className="productsAccordionCont">
                    <div className="productsAccordionDisc fx-ac space1">
                      <figure
                        className="fx-ac fx-jc"
                        onClick={(e) => {
                          setDisplayContent("previewAlpha");
                        }}
                      >
                        <span className="detialOpnPrcdt ">
                          <div className="fx-cl fx-ac fx-jc spacem">
                            <PrivacyTipOutlinedIcon
                              style={{
                                fontSize: "9.5rem",
                              }}
                            />
                            <span className="fs1">More detials!</span>
                          </div>
                        </span>

                        <span className="defaultPrdtIct">
                          <ShoppingCartIcon
                            style={{
                              fontSize: "9.5rem",
                            }}
                          />
                        </span>
                      </figure>
                      <div className="productsAccordionDetails g g4 space1">
                        <div className="fx-cl spacem">
                          <span>Batch</span>
                          <p>
                            <strong>
                              {item?.batch?.batches?.[0]?.batchNo}
                            </strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Item SKU</span>
                          <p>
                            <strong>{item?.sku}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Base Unit</span>
                          <p>
                            <strong>{item?.units?.baseUnit}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Expiry Date</span>
                          <p>
                            <strong>
                              {item?.batch?.batches?.[0]?.expiryDate}
                            </strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Warehouse</span>
                          <p>
                            <strong>{item?.warehouses?.[0]?.location}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Barcode</span>
                          <p>
                            <strong>{item?.barcode}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Stock Available</span>
                          <p>
                            <strong>{item?.stock?.quantityAvailable}</strong>
                          </p>
                        </div>
                        <div className="fx-cl spacem">
                          <span>Date Created</span>
                          <p>
                            <strong>
                              {" "}
                              {new Date(item?.createdAt).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric",
                                },
                              )}
                            </strong>
                          </p>
                        </div>

                        <div className="fx-ac space1">
                          <button
                            className="controlButtons"
                            style={{
                              cursor:
                                currentRows.length > 0
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentRows.length > 0 ? 1 : 0.6,
                            }}
                          >
                            <span>Return item</span>
                          </button>

                          <button
                            className="controlButtons"
                            style={{
                              cursor:
                                currentRows.length > 0
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentRows.length > 0 ? 1 : 0.6,
                            }}
                          >
                            <RemoveCircleOutlineIcon />
                            <span>Edit</span>
                          </button>

                          <button
                            className="controlButtons"
                            style={{
                              cursor:
                                currentRows.length > 0
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentRows.length > 0 ? 1 : 0.6,
                            }}
                          >
                            <LocalPrintshopIcon />
                            <span>Discount</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <button
                      className="previewProductBtn fx-ac spacem"
                      onClick={(e) => {
                        setDisplayContent("add-new-item");
                      }}
                    >
                      <CandlestickChartIcon fontSize="large" />
                      <span>Preview Product</span>
                    </button>
                  </span>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

       function CardView({ currentRows }) {
      return (
        <>
        {
           search.length > 0 ?
        <div className="item-products-grid">
          {filteredProductions?.map((product, index) => {
            const stock = product?.inventories?.[0]?.stock?.quantity ?? 0;

            const sellingPrice = product?.pricing?.sellingPrice ?? 0;

            const currency = product?.pricing?.currency || "NGN";

            const salesUnit = product?.units?.salesUnit || "Unit";

            const image = product?.images?.[0] || null;

            const brand = product?.brand || "";

            const sku = product?.sku || "";

            const status = product?.status || "";

            return (
              <article
                key={product?._id}
                className={`item-product-card ${
                  [
                    "item-card-themeOne",
                    "item-card-themeTwo",
                    "item-card-themeThree",
                    "item-card-themeFour",
                    "item-card-themeFive",
                  ][Math.floor(index / 4) % 5]
                }`}
                data-stock={stock}
                data-status={status}
                onClick={() => {
                  setSearchParams({ sku: product?.sku, index: index });
                  handleSubNavigator(
                    "item-explore-display",
                    "Item Preview",
                    "Item Preview",
                  );
                }}
              >
                {/* ============================================
                PRICE
            ============================================= */}

                <div className="item-product-card-price">
                  <span className="priceItemCont fx-ac spacem">
                    <span>{sellingPrice.toLocaleString()}</span>

                    <span>{currency}</span>
                  </span>
                </div>

                {/* ============================================
                PRODUCT IMAGE / ICON
            ============================================= */}
                <div className="itemCardTop fx-cl">
                  <div className="item-product-card-image-wrapper">
                    <div className="item-product-card-icon">
                      {image ? (
                        <img
                          src={image}
                          alt={product?.name || "Product"}
                          className="item-product-card-image"
                        />
                      ) : (
                        <InsertDriveFileIcon />
                      )}
                    </div>
                  </div>
                  {/* ==========================================
                  STOCK / DELIVERY BAR
              =========================================== */}

                  <div className="item-product-card-delivery">
                    {stock > 0
                      ? `Stock · ${stock} ${salesUnit}`
                      : "Out of stock"}
                  </div>
                </div>

                {/* ============================================
                PRODUCT CONTENT
            ============================================= */}

                <div className="item-product-card-content">
                  <div className="item-product-card-heading fx fx-ac fx-jb">
                    {/* PRODUCT NAME */}

                    <h3 className="item-product-card-name">{product?.name}</h3>

                    {/* ORDER / VIEW */}

                    <button type="button" className="item-product-card-order">
                      View
                      <ArrowOutward />
                    </button>
                  </div>

                  {/* ==========================================
                  PRODUCT TAGS
              =========================================== */}

                  <div className="item-product-card-tags">
                    {brand && (
                      <span className="item-product-card-tag">{brand}</span>
                    )}

                    {salesUnit && (
                      <span className="item-product-card-tag">{salesUnit}</span>
                    )}

                    {status && (
                      <span className="item-product-card-tag">{status}</span>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
        :
        <div className="item-products-grid">
          {productions?.map((product, index) => {
            const stock = product?.inventories?.[0]?.stock?.quantity ?? 0;

            const sellingPrice = product?.pricing?.sellingPrice ?? 0;

            const currency = product?.pricing?.currency || "NGN";

            const salesUnit = product?.units?.salesUnit || "Unit";

            const image = product?.images?.[0] || null;

            const brand = product?.brand || "";

            const sku = product?.sku || "";

            const status = product?.status || "";

            return (
              <article
                key={product?._id}
                className={`item-product-card ${
                  [
                    "item-card-themeOne",
                    "item-card-themeTwo",
                    "item-card-themeThree",
                    "item-card-themeFour",
                    "item-card-themeFive",
                  ][Math.floor(index / 4) % 5]
                }`}
                data-stock={stock}
                data-status={status}
                onClick={() => {
                  setSearchParams({ sku: product?.sku, index: index });
                  handleSubNavigator(
                    "item-explore-display",
                    "Item Preview",
                    "Item Preview",
                  );
                }}
              >
                {/* ============================================
                PRICE
            ============================================= */}

                <div className="item-product-card-price">
                  <span className="priceItemCont fx-ac spacem">
                    <span>{sellingPrice.toLocaleString()}</span>

                    <span>{currency}</span>
                  </span>
                </div>

                {/* ============================================
                PRODUCT IMAGE / ICON
            ============================================= */}
                <div className="itemCardTop fx-cl">
                  <div className="item-product-card-image-wrapper">
                    <div className="item-product-card-icon">
                      {image ? (
                        <img
                          src={image}
                          alt={product?.name || "Product"}
                          className="item-product-card-image"
                        />
                      ) : (
                        <InsertDriveFileIcon />
                      )}
                    </div>
                  </div>
                  {/* ==========================================
                  STOCK / DELIVERY BAR
              =========================================== */}

                  <div className="item-product-card-delivery">
                    {stock > 0
                      ? `Stock · ${stock} ${salesUnit}`
                      : "Out of stock"}
                  </div>
                </div>

                {/* ============================================
                PRODUCT CONTENT
            ============================================= */}

                <div className="item-product-card-content">
                  <div className="item-product-card-heading fx fx-ac fx-jb">
                    {/* PRODUCT NAME */}

                    <h3 className="item-product-card-name">{product?.name}</h3>

                    {/* ORDER / VIEW */}

                    <button type="button" className="item-product-card-order">
                      View
                      <ArrowOutward />
                    </button>
                  </div>

                  {/* ==========================================
                  PRODUCT TAGS
              =========================================== */}

                  <div className="item-product-card-tags">
                    {brand && (
                      <span className="item-product-card-tag">{brand}</span>
                    )}

                    {salesUnit && (
                      <span className="item-product-card-tag">{salesUnit}</span>
                    )}

                    {status && (
                      <span className="item-product-card-tag">{status}</span>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
        }</>
      );
    }
    return (
      <div className="fx-cl space2">
        <div className="fx-cl space2">
          <div className="fx-cl spacem">
            <div className="fx-ac fx-jb space2" style={{ fontSize: "1.2rem" }}>
              <span className="fx-ac spacem">
                <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                  Display:
                </strong>
                <span>
                  {itemsData?.length === 0
                    ? "0 to 0 of 0 entries"
                    : `${start + 1} to ${Math.min(
                        end,
                        itemsData?.length,
                      )} of ${itemsData?.length} entries`}
                </span>
              </span>
              <div className="products_entries-info fx-ac spacem">
                <h4>Rows</h4>
                <div className="products-page-limit">
                  <button
                    className="products-page-limit-btn"
                    onClick={() => setOpenLimit(!openLimit)}
                  >
                    {rowsPerPage} / page
                    <span className="products-page-limit-arrow">▾</span>
                  </button>

                  {openLimit && (
                    <ul className="products-limit-dropdown">
                      {[10, 20, 50, 100, 200, 500, 1000].map((n) => (
                        <li
                          key={n}
                          className="products-limit-item"
                          onClick={() => {
                            setRowsPerPage(n);
                            setCurrentPage(1);
                            setOpenLimit(false);
                          }}
                        >
                          {n} / page
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="products_row" id="printable">
              {switchView()}
            </div>
            <div className="fx-jc">
              <div className="products_pagination fx-ac space2">
                <button
                  className="fx-ac spacem"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  <SkipPreviousIcon />
                  Prev
                </button>
                <div className="fx-ac">
                  {getPagination(currentPage, totalPages)?.map((page, i) =>
                    page === "..." ? (
                      <span key={i} className="dots">
                        …
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`products_jumpto ${
                          currentPage === page ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ),
                  )}
                </div>

                <button
                  className="fx-ac spacem"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                  <SkipNextIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  function Services({ search, setSearch, setSearchParams }) { 

    const filteredServices = services?.filter((product) =>
      product.name.toLowerCase().includes(search.toLowerCase()),
    );
    function switchView() {
      switch (changeview) {
        case "grid":
          return <CardView currentRows={currentRows} />;
        case "table":
          return <TableView currentRows={currentRows} />;
        default:
          return <TableView currentRows={currentRows} />;
      }
    }

    function TableView() {
      const [openItemDrpdwn, setOpenItemDrpdwn] = useState(false);
      const [accordion, setAccordion] = useState(null);
      const [brands, setBrands] = useState("All brands");
      const [activeRow, setActiveRow] = useState(null);
      const dispatch = useDispatch();

      function handleItemDrpdwn(index) {
        setOpenItemDrpdwn(!openItemDrpdwn);
        if (activeRow === index) {
          setActiveRow(null);
        } else {
          setActiveRow(index);
        }
      }

      return (
        <div className="products ">
          <table className="fx-cl spacem">
            <thead className="fx-cl spacem">
              <tr>
                <th>Service Name</th>
                <th>Category</th>
                <th>Brand</th>
                <th>Purchase Price</th>
                <th>Selling Price</th>
                <th>Stock</th>
                <th>Unit</th>
                <th>Location</th>
                <th>Status</th>
              </tr>
            </thead>
            {search.length > 0 ? (
              <tbody className="fx-cl spacem">
                {filteredServices?.map((item, index) => (
                  <tr
                    key={index}
                    id={`${accordion === index && "productsAccordionOpen"}`}
                    className="productsRowTdCont fx-cl space1 relative"
                  >
                    <td
                      id={item?.sku}
                      className={`productsRowTd ${activeRow === index && "active_warehauseRow"}`}
                      onClick={() =>
                        accordion === index
                          ? setAccordion(null)
                          : setAccordion(index)
                      }
                    >
                      <span>
                        <strong>{item?.name}</strong>
                      </span>
                      <span>{item?.categoryId}</span>
                      <span>{item?.brand}</span>
                      <span>₦{item?.pricing?.costPrice?.toLocaleString()}</span>
                      <span>
                        ₦{item?.pricing?.sellingPrice?.toLocaleString()}
                      </span>
                      <span>{item?.inventories[0]?.quantity}</span>
                      <span>{item?.units?.baseUnit}</span>
                      <span>{item?.inventories?.[0]?.location}</span>
                      <span>{item?.status}</span>
                    </td>

                    <span className="productsAccordionCont">
                      <div className="productsAccordionDisc fx-ac space1">
                        <figure
                          className="fx-ac fx-jc"
                          onClick={(e) => {
                            setDisplayContent("previewAlpha");
                          }}
                        >
                          <span className="detialOpnPrcdt ">
                            <div className="fx-cl fx-ac fx-jc spacem">
                              <PrivacyTipOutlinedIcon
                                style={{
                                  fontSize: "9.5rem",
                                }}
                              />
                              <span className="fs1">More detials!</span>
                            </div>
                          </span>

                          <span className="defaultPrdtIct">
                            <ShoppingCartIcon
                              style={{
                                fontSize: "9.5rem",
                              }}
                            />
                          </span>
                        </figure>
                        <div className="productsAccordionDetails g g4 space1">
                          <div className="fx-cl spacem">
                            <span>Batch</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.batchNo}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Item SKU</span>
                            <p>
                              <strong>{item?.sku}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Base Unit</span>
                            <p>
                              <strong>{item?.units?.baseUnit}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Expiry Date</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.expiryDate}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Warehouse</span>
                            <p>
                              <strong>{item?.warehouses?.[0]?.location}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Barcode</span>
                            <p>
                              <strong>{item?.barcode}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Stock Available</span>
                            <p>
                              <strong>{item?.stock?.quantityAvailable}</strong>
                            </p>
                          </div>
                          <div className="fx-cl spacem">
                            <span>Date Created</span>
                            <p>
                              <strong>
                                {" "}
                                {new Date(item?.createdAt).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  },
                                )}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-ac space1">
                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <span>Return item</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                              <span>Edit</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <LocalPrintshopIcon />
                              <span>Discount</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <button
                        className="previewProductBtn fx-ac spacem"
                        onClick={(e) => {
                          setDisplayContent("add-new-item");
                        }}
                      >
                        <CandlestickChartIcon fontSize="large" />
                        <span>Preview Product</span>
                      </button>
                    </span>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody className="fx-cl spacem">
                {services?.map((item, index) => (
                  <tr
                    key={index}
                    id={`${accordion === index && "productsAccordionOpen"}`}
                    className="productsRowTdCont fx-cl space1 relative"
                  >
                    <td
                      id={item?.sku}
                      className={`productsRowTd ${activeRow === index && "active_warehauseRow"}`}
                      onClick={() =>
                        accordion === index
                          ? setAccordion(null)
                          : setAccordion(index)
                      }
                    >
                      <span>
                        <strong>{item?.name}</strong>
                      </span>
                      <span>{item?.categoryId}</span>
                      <span>{item?.brand}</span>
                      <span>₦{item?.pricing?.costPrice?.toLocaleString()}</span>
                      <span>
                        ₦{item?.pricing?.sellingPrice?.toLocaleString()}
                      </span>
                      <span>{item?.inventories[0]?.quantity}</span>
                      <span>{item?.units?.baseUnit}</span>
                      <span>{item?.inventories?.[0]?.location}</span>
                      <span>{item?.status}</span>
                    </td>

                    <span className="productsAccordionCont">
                      <div className="productsAccordionDisc fx-ac space1">
                        <figure
                          className="fx-ac fx-jc"
                          onClick={(e) => {
                            setDisplayContent("previewAlpha");
                          }}
                        >
                          <span className="detialOpnPrcdt ">
                            <div className="fx-cl fx-ac fx-jc spacem">
                              <PrivacyTipOutlinedIcon
                                style={{
                                  fontSize: "9.5rem",
                                }}
                              />
                              <span className="fs1">More detials!</span>
                            </div>
                          </span>

                          <span className="defaultPrdtIct">
                            <ShoppingCartIcon
                              style={{
                                fontSize: "9.5rem",
                              }}
                            />
                          </span>
                        </figure>
                        <div className="productsAccordionDetails g g4 space1">
                          <div className="fx-cl spacem">
                            <span>Batch</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.batchNo}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Item SKU</span>
                            <p>
                              <strong>{item?.sku}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Base Unit</span>
                            <p>
                              <strong>{item?.units?.baseUnit}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Expiry Date</span>
                            <p>
                              <strong>
                                {item?.batch?.batches?.[0]?.expiryDate}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Warehouse</span>
                            <p>
                              <strong>{item?.warehouses?.[0]?.location}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Barcode</span>
                            <p>
                              <strong>{item?.barcode}</strong>
                            </p>
                          </div>

                          <div className="fx-cl spacem">
                            <span>Stock Available</span>
                            <p>
                              <strong>{item?.stock?.quantityAvailable}</strong>
                            </p>
                          </div>
                          <div className="fx-cl spacem">
                            <span>Date Created</span>
                            <p>
                              <strong>
                                {" "}
                                {new Date(item?.createdAt).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  },
                                )}
                              </strong>
                            </p>
                          </div>

                          <div className="fx-ac space1">
                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <span>Return item</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                              <span>Edit</span>
                            </button>

                            <button
                              className="controlButtons"
                              style={{
                                cursor:
                                  currentRows.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentRows.length > 0 ? 1 : 0.6,
                              }}
                            >
                              <LocalPrintshopIcon />
                              <span>Discount</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <button
                        className="previewProductBtn fx-ac spacem"
                        onClick={(e) => {
                          setDisplayContent("add-new-item");
                        }}
                      >
                        <CandlestickChartIcon fontSize="large" />
                        <span>Preview Product</span>
                      </button>
                    </span>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      );
    }

      function CardView({ currentRows }) {
      return (
        <>
        {search.length > 0 ? 
        (
        <div className="item-products-grid">
          {filteredServices?.map((product, index) => {
            const stock = product?.inventories?.[0]?.stock?.quantity ?? 0;

            const sellingPrice = product?.pricing?.sellingPrice ?? 0;

            const currency = product?.pricing?.currency || "NGN";

            const salesUnit = product?.units?.salesUnit || "Unit";

            const image = product?.images?.[0] || null;

            const brand = product?.brand || "";

            const sku = product?.sku || "";

            const status = product?.status || "";

            return (
              <article
                key={product?._id}
                className={`item-product-card ${
                  [
                    "item-card-themeOne",
                    "item-card-themeTwo",
                    "item-card-themeThree",
                    "item-card-themeFour",
                    "item-card-themeFive",
                  ][Math.floor(index / 4) % 5]
                }`}
                data-stock={stock}
                data-status={status}
                onClick={() => {
                  setSearchParams({ sku: product?.sku, index: index });
                  handleSubNavigator(
                    "item-explore-display",
                    "Item Preview",
                    "Item Preview",
                  );
                }}
              >
                {/* ============================================
                PRICE
            ============================================= */}

                <div className="item-product-card-price">
                  <span className="priceItemCont fx-ac spacem">
                    <span>{sellingPrice.toLocaleString()}</span>

                    <span>{currency}</span>
                  </span>
                </div>

                {/* ============================================
                PRODUCT IMAGE / ICON
            ============================================= */}
                <div className="itemCardTop fx-cl">
                  <div className="item-product-card-image-wrapper">
                    <div className="item-product-card-icon">
                      {image ? (
                        <img
                          src={image}
                          alt={product?.name || "Product"}
                          className="item-product-card-image"
                        />
                      ) : (
                        <InsertDriveFileIcon />
                      )}
                    </div>
                  </div>
                  {/* ==========================================
                  STOCK / DELIVERY BAR
              =========================================== */}

                  <div className="item-product-card-delivery">
                    {stock > 0
                      ? `Stock · ${stock} ${salesUnit}`
                      : "Out of stock"}
                  </div>
                </div>

                {/* ============================================
                PRODUCT CONTENT
            ============================================= */}

                <div className="item-product-card-content">
                  <div className="item-product-card-heading fx fx-ac fx-jb">
                    {/* PRODUCT NAME */}

                    <h3 className="item-product-card-name">{product?.name}</h3>

                    {/* ORDER / VIEW */}

                    <button type="button" className="item-product-card-order">
                      View
                      <ArrowOutward />
                    </button>
                  </div>

                  {/* ==========================================
                  PRODUCT TAGS
              =========================================== */}

                  <div className="item-product-card-tags">
                    {brand && (
                      <span className="item-product-card-tag">{brand}</span>
                    )}

                    {salesUnit && (
                      <span className="item-product-card-tag">{salesUnit}</span>
                    )}

                    {status && (
                      <span className="item-product-card-tag">{status}</span>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>)
        : 
        (
        <div className="item-products-grid">
          {services?.map((product, index) => {
            const stock = product?.inventories?.[0]?.stock?.quantity ?? 0;

            const sellingPrice = product?.pricing?.sellingPrice ?? 0;

            const currency = product?.pricing?.currency || "NGN";

            const salesUnit = product?.units?.salesUnit || "Unit";

            const image = product?.images?.[0] || null;

            const brand = product?.brand || "";

            const sku = product?.sku || "";

            const status = product?.status || "";

            return (
              <article
                key={product?._id}
                className={`item-product-card ${
                  [
                    "item-card-themeOne",
                    "item-card-themeTwo",
                    "item-card-themeThree",
                    "item-card-themeFour",
                    "item-card-themeFive",
                  ][Math.floor(index / 4) % 5]
                }`}
                data-stock={stock}
                data-status={status}
                onClick={() => {
                  setSearchParams({ sku: product?.sku, index: index });
                  handleSubNavigator(
                    "item-explore-display",
                    "Item Preview",
                    "Item Preview",
                  );
                }}
              >
                {/* ============================================
                PRICE
            ============================================= */}

                <div className="item-product-card-price">
                  <span className="priceItemCont fx-ac spacem">
                    <span>{sellingPrice.toLocaleString()}</span>

                    <span>{currency}</span>
                  </span>
                </div>

                {/* ============================================
                PRODUCT IMAGE / ICON
            ============================================= */}
                <div className="itemCardTop fx-cl">
                  <div className="item-product-card-image-wrapper">
                    <div className="item-product-card-icon">
                      {image ? (
                        <img
                          src={image}
                          alt={product?.name || "Product"}
                          className="item-product-card-image"
                        />
                      ) : (
                        <InsertDriveFileIcon />
                      )}
                    </div>
                  </div>
                  {/* ==========================================
                  STOCK / DELIVERY BAR
              =========================================== */}

                  <div className="item-product-card-delivery">
                    {stock > 0
                      ? `Stock · ${stock} ${salesUnit}`
                      : "Out of stock"}
                  </div>
                </div>

                {/* ============================================
                PRODUCT CONTENT
            ============================================= */}

                <div className="item-product-card-content">
                  <div className="item-product-card-heading fx fx-ac fx-jb">
                    {/* PRODUCT NAME */}

                    <h3 className="item-product-card-name">{product?.name}</h3>

                    {/* ORDER / VIEW */}

                    <button type="button" className="item-product-card-order">
                      View
                      <ArrowOutward />
                    </button>
                  </div>

                  {/* ==========================================
                  PRODUCT TAGS
              =========================================== */}

                  <div className="item-product-card-tags">
                    {brand && (
                      <span className="item-product-card-tag">{brand}</span>
                    )}

                    {salesUnit && (
                      <span className="item-product-card-tag">{salesUnit}</span>
                    )}

                    {status && (
                      <span className="item-product-card-tag">{status}</span>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>)
        }
          </>
      );
    }
    return (
      <div className="fx-cl space2">
        <div className="fx-cl space2">
          <div className="fx-cl spacem">
            <div className="fx-ac fx-jb space2" style={{ fontSize: "1.2rem" }}>
              <span className="fx-ac spacem">
                <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                  Display:
                </strong>
                <span>
                  {itemsData?.length === 0
                    ? "0 to 0 of 0 entries"
                    : `${start + 1} to ${Math.min(
                        end,
                        itemsData?.length,
                      )} of ${itemsData?.length} entries`}
                </span>
              </span>
              <div className="products_entries-info fx-ac spacem">
                <h4>Rows</h4>
                <div className="products-page-limit">
                  <button
                    className="products-page-limit-btn"
                    onClick={() => setOpenLimit(!openLimit)}
                  >
                    {rowsPerPage} / page
                    <span className="products-page-limit-arrow">▾</span>
                  </button>

                  {openLimit && (
                    <ul className="products-limit-dropdown">
                      {[10, 20, 50, 100, 200, 500, 1000].map((n) => (
                        <li
                          key={n}
                          className="products-limit-item"
                          onClick={() => {
                            setRowsPerPage(n);
                            setCurrentPage(1);
                            setOpenLimit(false);
                          }}
                        >
                          {n} / page
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="products_row" id="printable">
              {switchView()}
            </div>
            <div className="fx-jc">
              <div className="products_pagination fx-ac space2">
                <button
                  className="fx-ac spacem"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  <SkipPreviousIcon />
                  Prev
                </button>
                <div className="fx-ac">
                  {getPagination(currentPage, totalPages)?.map((page, i) =>
                    page === "..." ? (
                      <span key={i} className="dots">
                        …
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`products_jumpto ${
                          currentPage === page ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ),
                  )}
                </div>

                <button
                  className="fx-ac spacem"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                  <SkipNextIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function handleModalFunction(toggleModal, displayModal) {
    setModalInfo(displayModal);
    setModalOpen(toggleModal);
  }
  function loopingModalInfo() {
    switch (modalInfo) {
      case "filters":
        return <FilterProducts />;

      default:
        break;
    }
  }

  function switchContentDisplay() {
    switch (displayContent) {
      case "main-display":
        return <ProductMain />; 
      default:
        break;
    }
  }
  function ProductMain() {
    return (
      <div className="fx-cl space2">
        {/* <div className="products_breadcrumbs fx-ac">
          <Link className="fx-ac spacem">
            <strong>{breadcrumbs.active && breadcrumbs.active_title}</strong>{" "}
            <KeyboardArrowRightIcon fontSize="small" />{" "}
          </Link>
          <Link className="fx-ac spacem">
            <span>
              {breadcrumbs.active_display_title &&
                breadcrumbs.active_display_title}
            </span>
            <KeyboardArrowRightIcon fontSize="small" />
            <span>{currentTab && currentTab}</span>
          </Link>
        </div> */}

        <div>
          {loading ? (
            <IsLoading />
          ) : (
            <div className="products_main">{switchActiveTab()}</div>
          )}
        </div>
      </div>
    );
  }

  useEffect(() => {
    apiGetAllItems();
  }, []);

  const ItemHeader = () => {
    return (
      <header className="item-header">
        {/* =========================
          TOP NAVIGATION
      ========================== */}
        <div className="item-header-top fx fx-ac fx-jb">
          {/* LEFT */}
          <div className="item-header-title fs4 fw500">
            {breadcrumbs.active_title}
          </div>

          {/* CENTER / RIGHT NAVIGATION */}
          <div className="item-header-navigation fx fx-ac space3">
            <button className="item-header-nav-button fx fx-ac space">
              <FolderZipOutlinedIcon className="item-header-nav-icon" />
              <span>Levels</span>
            </button>
 

            <button className="item-header-nav-button fx fx-ac space">
              <Settings className="item-header-nav-icon" />
              <span>Bulk import</span>
            </button>

            {/* TIME NAVIGATION */}
            <div className="item-header-time-control fx fx-ac">
              <button className="item-header-icon-button">
                <ChevronLeft />
              </button>

              <button className="item-header-time-button fx fx-ac space">
                <AccessTime />
                <span>All locations</span>
                <KeyboardArrowDown />
              </button>

              <span className="item-header-timezone">INV..</span>

              <button className="item-header-icon-button">
                <ArrowForward />
              </button>

              <button className="item-header-icon-button">
                <ChevronRight />
              </button>
            </div>
            {/* LIVE */}
            <button
              onClick={(e) => {
                e.stopPropagation(); // stop bubbling to document
                handleModalFunction(!modalOpen, "filters");
              }}
              className="item-header-live-button"
            >
              <CandlestickChartIcon />
            </button>

            {/* LEARN */}
            <button
              onClick={(e) => {
                handleSubNavigator(
                    "add-new-item",
                    "Item Create",
                    "Item Create",
                  ); 
              }}
              id="addNewItem"
              className="item-header-nav-button fx-ac spacem"
            >
              {" "}
              <PostAddIcon className="item-header-nav-icon" fontSize="large" />
              <span>Add New Item</span>
            </button>
          </div>
        </div>

        <div className="item-header-ribbons fx-cl">
          {/* =========================
          QUERY BAR
      ========================== */}
          <div className="item-header-query-row fx fx-ac fx-jb space3">
            <div className="fx-ac spacem" style={{ flex: "1" }}>
              {/* PROJECT LOGS */}
              {/* <button className="item-header-project-button fx fx-ac space">
                <SwapVertIcon />
                <span>Item name</span>
                <KeyboardArrowDown />
              </button> */}
              <ItemSortDropdown itemsData={itemsData} setItemsData={setItemsData }  sortConfig={sortConfig}
  setSortConfig={setSortConfig} />

              {/* SEARCH */}
              <div className="item-header-search fx fx-ac space">
                <Search />
                <input
                  type="text"
                  placeholder="Search all fields"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>


            {/* ICONS BUTTON */}
            <div className="item-header-action-button fx-ac space2">
             <div className="itemsData__viewSwitcher">
  <button
    type="button"
    className="itemsData__iconBtn"
    onClick={() => setIsViewDropdownOpen((prev) => !prev)}
  >
    {changeview === "list" ? (
      <ListAltIcon fontSize="large" />
    ) : changeview === "grid" ? (
      <AppsOutlinedIcon fontSize="large" />
    ) : (
      <ListAltIcon fontSize="large" />
    )}
  </button>

  {isViewDropdownOpen && (
    <div className="itemsData__viewDropdown">
      <button
        type="button"
        className={`itemsData__viewDropdownItem ${
          changeview === "list" ? "active" : ""
        }`}
        onClick={() => {
          setChangeView("list");
          setIsViewDropdownOpen(false);
        }}
      >
        <ListAltIcon />
        <span>List View</span>
      </button>

      <button
        type="button"
        className={`itemsData__viewDropdownItem ${
          changeview === "grid" ? "active" : ""
        }`}
        onClick={() => {
          setChangeView("grid");
          setIsViewDropdownOpen(false);
        }}
      >
        <AppsOutlinedIcon />
        <span>Card View</span>
      </button>

      <button
        type="button"
        className={`itemsData__viewDropdownItem ${
          changeview === "table" ? "active" : ""
        }`}
        onClick={() => {
          setChangeView("table");
          setIsViewDropdownOpen(false);
        }}
      >
        <ListAltIcon />
        <span>Table View</span>
      </button>
    </div>
  )}
</div>
              <button
                className="iconBtn printingBtn"
                onClick={() =>
                  handlePrint({
                    currentRows: currentRows,
                    tab: currentTab,
                  })
                }
              >
                <PrintIcon fontSize="large" />
              </button>
              {/* PDF EXPORT */}
              <ExportPDFButton currentRows={currentRows} />
              {/* EXCEL EXPORT */}
              <ExportExcelJSButton currentRows={currentRows} />
            </div>
          </div>

          {/* =========================
          FILTER BAR
      ========================== */}
          <div className="item-header-filter-row fx fx-ac space">
            <button
              onClick={() => handleCurrentTAB("items-data")}
              className={`item-header-filter-button  fx-ac space1 ${
                currentTab === "items-data" && "active-item-tab"
              }`}
            >
              <span>All Items</span>
              <figure className="itemsCountTag">
                {itemsData?.length || 0}
              </figure>
            </button>

            <button
              onClick={() => handleCurrentTAB("products")}
              className={`item-header-filter-button fx fx-ac space ${currentTab === "products" && "active-item-tab"}`}
            >
              <span>Products</span>
              <figure className="itemsCountTag">{products?.length || 0}</figure>
            </button>

            <button
              onClick={() => handleCurrentTAB("productions")}
              className={`item-header-filter-button fx fx-ac space ${currentTab === "productions" && "active-item-tab"}`}
            >
              <span>Productions</span>
              <figure className="itemsCountTag">
                {productions?.length || 0}
              </figure>
            </button>

            <button
              onClick={() => handleCurrentTAB("services")}
              className={`item-header-filter-button fx fx-ac space ${currentTab === "services" && "active-item-tab"}`}
            >
              <span>Services</span>
              <figure className="itemsCountTag">{services?.length || 0}</figure>
            </button>
 

            <div className="fg1" />

            {/* SHOW QUERY */}
            <div className="item-header-show-query fx fx-ac space">
              <div className="item-header-toggle">
                <div className="item-header-toggle-circle" />
              </div>

              <span>Show query</span>
            </div>
          </div>
        </div>
      </header>
    );
  };
  return (
    <>
      {modalOpen && (
        <div
          className="client_modal_overlay fx-jc fx-ac"
          onClick={() => handleModalFunction(false, "")} // click outside → close
        >
          <div
            className="client_modal"
            onClick={(e) => e.stopPropagation()} // click inside → stay open
          >
            {loopingModalInfo()}
          </div>
        </div>
      )}
      <div className="fx-cl spacem">
        <ItemHeader
          search={search}
          setSearch={setSearch}
          breadcrumbs={breadcrumbs}
          changeview={changeview}
          setChangeView={setChangeView}
          handlePrint={handlePrint}
          currentRows={currentRows}
          currentTab={currentTab}
        />
        {switchContentDisplay()}
      </div>
    </>
  );
}
